/*
 * The brand kit's icon set, inlined from `design/brand-kit/icons.json`.
 *
 * The whole set is 1.4 KB of path data, which is smaller than the request that would fetch a
 * sprite — and unlike a sprite it survives being rendered before the network settles. The SVG
 * files in the kit stay the designer's source; this file is what was generated from them, so
 * regenerate it from `icons.json` rather than editing paths by hand.
 */
export const ICON_PATHS = {
  agenda: 'M7 3v3M17 3v3M4 9h16M5 6h14a1 1 0 011 1v12a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1z',
  star: 'M12 4l2.4 5 5.6.8-4 4 1 5.5L12 16.7 7 19.3l1-5.5-4-4L9.6 9z',
  matches:
    'M9 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM3 20c0-3 2.7-4.5 6-4.5M16 6.2a3.2 3.2 0 010 6.1M18.5 20c0-2.1-1.3-3.5-3.3-4.1',
  people:
    'M8.5 11a3 3 0 100-6 3 3 0 000 6zM2.5 20c0-3.3 2.7-5 6-5s6 1.7 6 5M17 6.3a3 3 0 010 5.9M18 15.2c2 .6 3.5 2.1 3.5 4.3',
  speakers: 'M12 4a3 3 0 013 3v4a3 3 0 01-6 0V7a3 3 0 013-3zM6 11a6 6 0 0012 0M12 17v4M9 21h6',
  bell: 'M6 9a6 6 0 1112 0c0 4 1.5 5.5 1.5 5.5H4.5S6 13 6 9zM10 18.5a2 2 0 004 0',
  map: 'M12 21s6.5-6 6.5-10.5a6.5 6.5 0 10-13 0C5.5 15 12 21 12 21zM12 12.5a2.2 2.2 0 100-4.4 2.2 2.2 0 000 4.4z',
  golf: 'M8 21h8M11 21V4l7 3.5-7 3.5M11 14.5c-3 .4-5 1.7-5 3',
  heart: 'M12 20s-7-4.3-7-9a4 4 0 017-2.6A4 4 0 0119 11c0 4.7-7 9-7 9z',
  bag: 'M6 8h12l1 12H5L6 8zM9 8V6a3 3 0 016 0v2',
  'chevron-right': 'M9 6l6 6-6 6',
  'chevron-left': 'M15 6l-6 6 6 6',
  search: 'M11 4a7 7 0 100 14 7 7 0 000-14zM16.5 16.5L21 21',
  share: 'M12 4v11M8 7.5L12 3.5l4 4M5 15v4a1 1 0 001 1h12a1 1 0 001-1v-4',
  check: 'M5 13l4.5 4.5L19 7',
  external: 'M7 17L17 7M9 7h8v8',
  home: 'M4 11l8-6.5 8 6.5M6 10v9a1 1 0 001 1h10a1 1 0 001-1v-9',
  profile: 'M12 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM5 20c0-3.4 3.1-5.5 7-5.5s7 2.1 7 5.5',
  // Sliders rather than a cog: the console's own screen, and a cog at this stroke weight turns
  // into a blob by the time it is 18px in a sidebar.
  settings:
    'M4 7h3M11 7h9M4 12h9M17 12h3M4 17h6M14 17h6M9 9a2 2 0 100-4 2 2 0 000 4M15 14a2 2 0 100-4 2 2 0 000 4M12 19a2 2 0 100-4 2 2 0 000 4',
} as const;

export type IconName = keyof typeof ICON_PATHS;

export const ICON_NAMES = Object.keys(ICON_PATHS) as IconName[];

export function isIconName(value: string): value is IconName {
  return value in ICON_PATHS;
}
